import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AddressesService} from "../../services/addresses-service.factory";


export class AddressesResolverViewCtrl implements IController {

  quality: any;
  address: any;

  public showEditResults: boolean;
  private shouldChangeStreetName: boolean;
  public isAbleToContinue: boolean;
  private filterConfig: any;
  private doReload: any;
  private editingAddress: any;
  private selectedAddress: any;
  public exactAddressResolution: boolean = false;
  public servicesList: any[];
  public ordersList: any[];

  /* @ngInject */
  constructor(private $state, private addressesService: AddressesService) {
  }

  $onInit() {
    this.shouldChangeStreetName = false;
    this.showEditResults = false;

    this.doReload = undefined;

    this.editingAddress = undefined;
    this.selectedAddress = undefined;

    this.filterConfig = {
      queryString: undefined,
      isResolved: true
    };

    if (this.address) {
      this.onEditAddress(this.address);
    }
  };

  onQualityChange(quality) {
    this.editingAddress = undefined;
    this.selectedAddress = undefined;
    this.quality = quality;

    this.$state.go('.', {quality: quality}, {notify: false, reload: false})
  }

  onQueryChange(query) {
    this.filterConfig.queryString = query;
  }

  onCancelEditing() {
    this.editingAddress = undefined;
    this.showEditResults = false;
    this.shouldChangeStreetName = false;
    this.isAbleToContinue = false;
    this.servicesList = undefined;
    this.ordersList = undefined;
  }

  onBackToEditing() {
    this.showEditResults = false;
  }

  onReload() {
    this.doReload = undefined;
  }


  onLocationSelect(location) {
    _.set(this.editingAddress, "editingAddress.validatedAddress.location", location)
  }


  onSelectAddress(address) {
    this.selectedAddress = address;
  }

  onCloseResolvePanel() {
    this.selectedAddress = undefined;
  }


  onEditAddress(address) {
    this.selectedAddress = angular.copy(address);

    this.editingAddress = this._setValidatedAddress(address);
    this.shouldChangeStreetName = false;

  }

  onValidatedAddressChange(address) {
    this.editingAddress.validatedAddress = address;
    this.isAbleToContinue = this._isOriginalAndValidatedEqual(this.editingAddress.originalAddress, this.editingAddress.validatedAddress);
  }


  onAddressEditingDone() {
    this.showEditResults = true;
  }

  onToggleExactAddressResolution(exactAddressResolution: boolean) {
    this.exactAddressResolution = exactAddressResolution;
  }

  onSaveAddress() {
    this.editingAddress.resolved = true;

    this.addressesService.updateAddress(this.editingAddress, false, false, this.exactAddressResolution)
        .then((updatedAddress) => {

        })
        .finally(() => {
          this.onCancelEditing();
        });
  }

  onChangeStreetName(shouldChangeStreetName) {
    if (!this.servicesList && !this.ordersList) {
      this.getOrdersAndDeliveriesUsingAddress();
    }
    this.shouldChangeStreetName = shouldChangeStreetName;
  }


  //////////////////////////////////// Private Methods ////////////////////////////////////

  private _setValidatedAddress(address) {
    if (_.isUndefined(address.validatedAddress)) {
      _.set(address, 'validatedAddress.house', address.originalAddress.house);
      _.set(address, 'validatedAddress.street', address.originalAddress.street);
      _.set(address, 'validatedAddress.city', address.originalAddress.city);
      _.set(address, 'validatedAddress.state', address.originalAddress.state);
      _.set(address, 'validatedAddress.country', address.originalAddress.country);
      _.set(address, 'validatedAddress.zipCode', address.originalAddress.zipCode);

      _.set(address, "validatedAddress.location", angular.copy(address.originalAddress.location))
    }
    return address;
  }

  private _isOriginalAndValidatedEqual(originalAddress, validatedAddress): boolean {
    return originalAddress.house != validatedAddress.house ||
        originalAddress.street != validatedAddress.street ||
        originalAddress.city != validatedAddress.city ||
        originalAddress.state != validatedAddress.state ||
        originalAddress.country != validatedAddress.country ||
        originalAddress.zipCode != validatedAddress.zipCode ||

        originalAddress.location.longitude != validatedAddress.location.longitude ||
        originalAddress.location.latitude != validatedAddress.location.latitude ||
        originalAddress.location.lng != validatedAddress.location.lng ||
        originalAddress.location.lat != validatedAddress.location.lat
  }

  private getOrdersAndDeliveriesUsingAddress() {
    return this.addressesService.getOrdersAndDeliveriesUsingAddress(this.editingAddress.id)
        .then((res) => {
          this.servicesList = res.services;
          this.ordersList = res.orders;
        })
  }

}

angular
    .module('bringoz.admin.addresses')
    .component('addressesResolverView', {
      bindings: {
        quality: '<',
        address: '<'
      },
      template: require('./addresses-resolver-view.html').default,
      controller: AddressesResolverViewCtrl
    });
